// app/components/BlockBrowserZoom.tsx (App Router) OR src/components/BlockBrowserZoom.tsx
'use client';

import { useEffect } from 'react';

export default function BlockBrowserZoom() {
  useEffect(() => {
    const onKeyDown = (e) => {
      const isZoomCombo = (e.ctrlKey || e.metaKey) && (
        e.key === '+' ||
        e.key === '-' ||
        e.key === '=' ||   // Ctrl + = is zoom-in on many keyboards
        e.key === '_' ||
        e.key === '0'      // Ctrl + 0 reset zoom
      );

      if (isZoomCombo) e.preventDefault();
    };

    const onWheel = (e) => {
      // Ctrl + wheel zoom (Chrome/Windows etc.)
      if (e.ctrlKey) e.preventDefault();
    };

    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('wheel', onWheel, { passive: false });

    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('wheel', onWheel);
    };
  }, []);

  return null;
}
